module.exports = __webpack_public_path__ + "img/EducationalJoiningApplications.f3ad7375.svg";